import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';

import SectionHeading from '@/app/components/SectionHeading';

const ScienceAndResearchJumbotron = () => {
  return (
    <section
      className="py-20 md:mt-10 lg:mt-14"
      data-cy="science-and-research-jumbotron"
    >
      <LayoutGrid>
        <GridItem
          colStart={{
            sm: 'main',
            md: 'main',
          }}
          colEnd={{
            sm: 'main',
            md: 'main',
          }}
        >
          <SectionHeading
            animated
            content={'science_and_research_cutting_edge'}
            emAnimationProps={{
              transition: { delay: 0.5, duration: 1, type: 'tween' },
              viewport: { once: true },
            }}
            typographyProps={{
              align: 'center',
              className:
                'leading-tight tracking-tighter lg:px-20 xl:px-44 md:px-20 px-8',
              color: 'inherit',
              Element: 'h3',
              variant: 'h2',
            }}
            wrapperAnimationProps={{
              initial: { filter: 'blur(5px)', opacity: 0 },
              transition: { delay: 0.2, duration: 0.75, type: 'tween' },
            }}
          />
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default ScienceAndResearchJumbotron;
